import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class RealTimeService {
    constructor() {}
    private realTimeSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public realTime$: Observable<any> = this.realTimeSubject.asObservable();

    getRealTime(): any {
        return this.realTimeSubject.getValue();
    }

    setRealTime(newValue: any): void {
        this.realTimeSubject.next(newValue);
    }
}
